import { Suspense, useEffect, useState } from 'react';
import {
  Outlet,
  Route,
  Routes,
  useNavigate,
  useLocation,
} from 'react-router-dom';
import { pageRoutes } from './routes';
import { routeTypes } from '../types';
import PrivateRoute from './customRoute';
import { RootState, useAppSelector } from '../redux/store';
import Loading from '../Components/Loading';
import NotificationService from '../Components/NotificationComponent';
import { ROUTES } from '../helpers/contants';
import { useDispatch } from 'react-redux';
import { setCommonMenu } from '../redux/commonSlice';
import { setActiveChat } from '../Pages/Chats/chat.slice';

function RoutesWrapper() {
  const { status, token, isNewUser, isUserDetailsAdded } = useAppSelector(
    (state: RootState) => state.auth,
  );
  const { menu } = useAppSelector((state: RootState) => state.common);
  const { mainInbox, localChats } = useAppSelector(
    (state: RootState) => state.chat,
  );

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  // Global chat redirection handler
  useEffect(() => {
    const handleGlobalChatRedirection = () => {
      const urlParams = new URLSearchParams(location.search);
      const paramChatId = urlParams.get('paramChatId');

      if (paramChatId) {
        console.log('🔗 Global chat redirection detected:', paramChatId);

        // If not already on chat page, navigate to chat page
        if (!location.pathname.includes('/chats')) {
          console.log('🔄 Navigating to chat page...');
          navigate(ROUTES.CHATS + `?paramChatId=${paramChatId}`);
          return;
        }

        // If already on chat page, handle the redirection
        const allChats = [...localChats, ...mainInbox];
        const targetChat = allChats.find(chat => chat._id === paramChatId);

        if (targetChat) {
          console.log('✅ Found target chat:', targetChat);

          // Set the active chat
          dispatch(setActiveChat(paramChatId));

          // Clear the URL parameter to prevent re-redirecting
          const newUrl = new URL(window.location.href);
          newUrl.searchParams.delete('paramChatId');
          window.history.replaceState({}, '', newUrl.toString());

          console.log('✅ Global chat redirection completed');
        } else {
          console.log(
            '❌ Target chat not found, will retry when chat list loads',
          );
        }
      }
    };

    handleGlobalChatRedirection();
  }, [
    location.search,
    location.pathname,
    mainInbox,
    localChats,
    navigate,
    dispatch,
  ]);

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === 'token') {
        const newToken = event.newValue;
        if (token && newToken && token !== newToken) {
          // Token has changed in another tab
          navigate('/');
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [token]);

  const [isTabletOrSmaller, setIsTabletOrSmaller] = useState(
    window.innerWidth < 1024,
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 1024px)');

    const handleChange = (e: MediaQueryListEvent) => {
      setIsTabletOrSmaller(e.matches);
    };

    // Initial check
    setIsTabletOrSmaller(mediaQuery.matches);

    // Listen for changes
    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  useEffect(() => {
    console.log(isTabletOrSmaller, 'isTabletOrSmaller');

    // Always set menu visibility based on screen size directly
    dispatch(setCommonMenu(!isTabletOrSmaller));
  }, [isTabletOrSmaller]);

  return (
    <Suspense
      fallback={
        <Loading
          type="div"
          height="full"
          pageLoading={true}
          className="routerContainer"
        />
      }
    >
      <Routes>
        <Route
          element={
            <>
              <NotificationService />
              <Outlet />
            </>
          }
        >
          {pageRoutes.map((route: routeTypes) => {
            if (route.isPrivate) {
              return (
                <Route
                  key={route.id}
                  path={route.path}
                  element={
                    <PrivateRoute isLoggedIn={status}>
                      <div className="main">
                        {/* <Header /> */}
                        <div className="mainContainer">
                          <route.Component {...route.pageProp} />
                        </div>
                        {/* <Footer /> */}
                      </div>
                    </PrivateRoute>
                  }
                />
              );
            }

            return (
              <Route
                key={route.id}
                path={route.path}
                element={<route.Component {...route.pageProp} />}
              />
            );
          })}
          <Route path="*" element={<div>Error Screen here</div>} />
        </Route>
      </Routes>
    </Suspense>
  );
}

export default RoutesWrapper;
